import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useCreateBackofficeCustomerMutation } from "modules/backoffice/hooks/customers/useCreateBackofficeCustomerMutation"
import { useTranslation } from "react-i18next"
import { UpsertBackofficeCustomerBodySchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { BackofficeCustomerForm } from "./BackofficeCustomerForm"

type Props = {
  onOpenChange: () => void
}

export const BackofficeCustomerCreator = ({ onOpenChange }: Props) => {
  const { t } = useTranslation()
  const { mutateAsync } = useCreateBackofficeCustomerMutation()

  const onSubmit = async (data: z.input<typeof UpsertBackofficeCustomerBodySchema>) => {
    await mutateAsync(data)
    toast.success(t("backoffice.customers.editSuccess"))
    onOpenChange()
  }

  return (
    <Dialog onOpenChange={onOpenChange} open>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("backoffice.customers.create.title")}</DialogTitle>
          <DialogDescription>{t("backoffice.customers.create.description")}</DialogDescription>
        </DialogHeader>
        <BackofficeCustomerForm
          onSubmit={onSubmit}
          submitCopy={t("backoffice.customers.create.save")}
        />
      </DialogContent>
    </Dialog>
  )
}
